export const upsellingHc = {
  servicios: {
    accommodation: "Alojamiento",
    all: "Todos",
    state: "Estado",
    search: "Buscar",
    searchPlaceholder: "Huésped o código de reserva…",
    from: "Desde",
    to: "Hasta",
    today: "Hoy",
    noDate: "Sin fecha",
    clear: "Limpiar",
    thService: "Servicio",
    thGuest: "Huésped",
    thBooking: "Reserva",
    thRequested: "Solicitado",
    statusConsult: "A consultar",
    statusRejected: "Rechazado",
    statusPaid: "Pagado",
    statusPartial: "Pago parcial",
    statusApproved: "Aprobado",
    statusPending: "Pendiente",
    serviceFallback: "Servicio",
    openBookingTitle: "Abrir la reserva",
    approve: "Aprobar",
    reject: "Rechazar",
    viewBooking: "Ver reserva",
    noRecords: "Sin registros",
    noRecordsFiltered: "No se encontraron registros con los filtros aplicados.",
    noRequestsYet: "En cuanto un huésped pida un servicio aparecerá aquí.",
    chipBreakfast: "Desayuno",
    chipTour: "Tour",
    chipTransport: "Transporte",
    chipMore: "Y lo que ofrezcas",
    approveTitle: "Aprobar solicitud",
    amountLabel: "Importe a cobrar",
    amountFree: "0 = sin cargo",
    amountHint: "Con pasarela conectada, se le envía al huésped un <strong>link de pago</strong> (WhatsApp + correo). Si no, se le indica que <strong>pagará a su llegada</strong>.",
    cancel: "Cancelar",
    processing: "Procesando…",
    approveAndNotify: "Aprobar y avisar",
    amountInvalid: "Indica un importe válido (0 = sin cargo).",
    approvedPaymentLink: "Aprobada. Se envió el link de pago al huésped (WhatsApp + correo).",
    approvedOnArrival: "Aprobada. El huésped pagará a su llegada (sin pasarela conectada).",
    approvedNotified: "Aprobada. Se avisó al huésped.",
    approveFailed: "No se pudo aprobar la solicitud.",
    rejectTitle: "Rechazar solicitud",
    rejectMessage: "Al rechazarla, el huésped NO será cobrado por este servicio y se le avisará. ¿Rechazar la solicitud?",
    rejected: "Solicitud rechazada. Se avisó al huésped.",
    rejectFailed: "No se pudo rechazar la solicitud.",
  },
  form: {
    basicTitle: "Información básica",
    basicDesc: "El nombre y la descripción que verá el huésped.",
    autoTranslate: "Escríbelo en <strong>tu idioma</strong>. Al guardar se traduce <strong>automáticamente</strong> a todos los idiomas (español, inglés, portugués, francés, alemán, italiano, chino y árabe); el huésped verá el suyo.",
    selectPlaceholder: "Seleccionar…",
    catNightlife: "Ocio Nocturno",
    subtitleLabel: "Subtítulo",
    optional: "opcional",
    subtitlePlaceholder: "Un gancho corto, ej: “Vive la experiencia”",
    price: "Precio",
    priceDesc: "Cómo se cobra este servicio al huésped.",
    segWithPrice: "Con precio",
    segWithPriceDesc: "Se cobra automáticamente",
    segOnRequest: "A consultar",
    segOnRequestDesc: "El huésped pregunta, tú cotizas",
    currencyLabel: "Moneda",
    currencyHint: "la del anuncio",
    chargeBy: "Cobrar por",
    unitPlaceholder: "Elige el modo…",
    unitPerUnit: "Por unidad (precio fijo)",
    unitPerPerson: "Por persona (× huéspedes)",
    unitPerNight: "Por noche (× noches)",
    unitPerGroup: "Por grupo / estancia",
    unitPerHour: "Por hora",
    unitHintPerson: "Se multiplicará por el nº de huéspedes de la reserva.",
    unitHintNight: "Se multiplicará por el nº de noches de la reserva.",
    unitHintUnit: "Precio fijo por cada unidad que compre el huésped.",
    unitHintGroup: "Precio único por la reserva, sin importar personas ni noches.",
    unitHintHour: "Precio por hora contratada.",
    unitLabelPerson: "/ por persona",
    unitLabelNight: "/ por noche",
    unitLabelGroup: "/ por estancia",
    unitLabelHour: "/ por hora",
    stockControl: "Controlar stock",
    inventory: "inventario",
    stockDesc: "Para lo que se agota (ej. una cama o cuna extra): limita las unidades. Se descuentan solas con cada reserva y en tiempo real.",
    unitsAvailable: "Unidades disponibles",
    removeUnitAria: "Quitar una unidad",
    addUnitAria: "Añadir una unidad",
    stockNoteSoldOut: "A <strong>0</strong> unidades el servicio aparece <strong>Agotado</strong> y no se puede añadir.",
    stockNoteAuto: "Al llegar a 0 se mostrará <strong>Agotado</strong> automáticamente.",
    stockConsumePerson: "Cada reserva descuenta 1 unidad por huésped.",
    stockConsumeNight: "Cada reserva descuenta 1 unidad por noche.",
    stockModeTitle: "Cómo funciona el stock",
    stockModeAvail: "Por disponibilidad",
    stockModeAvailDesc: "Se ocupa solo durante la estancia y se libera al hacer checkout (cuna, cama extra).",
    stockModeProduct: "Por producto",
    stockModeProductDesc: "Se descuenta con cada reserva y no vuelve. Lo repones tú a mano.",
    stockUnlimited: "Stock ilimitado — sin límite de unidades.",
    photosTitle: "Fotos",
    photoMain: "Principal",
    makeMainTitle: "Hacer principal",
    removeTitle: "Quitar",
    addPhoto: "Añadir foto",
    addPhotos: "Añadir fotos",
    reorderHint: "Arrastra para reordenar · la primera es la que se muestra en la tarjeta.",
    whereTitle: "¿Dónde se ofrece?",
    whereDesc: "Anuncios donde estará disponible. Sin selección = todos.",
    selected: "{count} seleccionados",
    all: "Todos",
    none: "Ninguno",
    searchListingPlaceholder: "Buscar anuncio…",
    noResults: "Sin resultados",
    diffCurrencyTitle: "Este anuncio usa {currency}. Un servicio va en una sola moneda.",
    unit: "unidad",
    units: "unidades",
    loadingListings: "Cargando anuncios…",
    previewLabel: "Vista previa · así lo verá el huésped",
    previewPhoto: "Tu foto principal",
    previewTitleFallback: "Nombre del servicio",
    previewDescFallback: "Aquí aparecerá la descripción que escribas para que el huésped sepa qué incluye.",
    free: "Gratis",
    soldOut: "Agotado",
    add: "Añadir",
    remaining: "Quedan {count} unidad | Quedan {count} unidades",
    scopeManaged: "Se ofrece en <strong>todos tus anuncios</strong>. Elige en cuáles desde la lista de Servicios y experiencias.",
    scopeAll: "Disponible en <strong>todos tus alojamientos</strong>",
    scopeSome: "Disponible en <strong>{count}</strong> anuncio | Disponible en <strong>{count}</strong> anuncios",
    errNameRequired: "El nombre es requerido",
    errCategoryRequired: "La categoría es requerida",
    errDescRequired: "La descripción es requerida",
    errPriceRequired: "Introduce un precio (pon 0 si es gratis).",
    errPriceNegative: "El precio no puede ser negativo.",
    errUnitRequired: "Elige cómo se cobra (Cobrar por)",
    errStockRequired: "Indica cuántas unidades hay en stock (pon 0 si está agotado).",
    errProcessing: "Error al procesar la solicitud.",
  },
  createServicio: {
    subtitle: "Completa la información y mira la vista previa en tiempo real.",
    photosDesc: "Añade las que quieras · la 1ª es la principal · JPG, PNG o WebP.",
    imageRequired: "Sube al menos una imagen.",
  },
  updateServicio: {
    title: "Editar experiencia o servicio",
    subtitle: "Actualiza la información y mira la vista previa en tiempo real.",
    loadingAria: "Cargando servicio",
    photosDesc: "Añade o quita las que quieras · la 1ª es la principal · JPG, PNG o WebP.",
    save: "Guardar cambios",
    imageRequired: "Debe quedar al menos una imagen.",
    loadFailed: "No se pudo cargar el servicio.",
  },
  configUpselling: {
    title: "Configuración Ventas Cruzadas",
    phoneIntro: "Ingresa el número de teléfono que deseas utilizar para recibir las notificaciones de solicitudes de servicio a través de WhatsApp",
    saveWhatsapp: "Guardar WhatsApp",
    editWhatsapp: "Editar WhatsApp",
    mustEnterWhatsapp: "Debes ingresar el WhatsApp",
    swalTitle: "WhatsApp de ventas cruzadas",
    swalText: "Recibirás todas las notificaciones de los servicios solicitados por los clientes",
    cancel: "Cancelar",
    addedSuccess: "WhatsApp agregado con éxito",
  },
};
